
<div class="wrapper">
    <div class="sidebar removeScrollParent" data-background-color="black" data-active-color="danger">
        <sidebar-cmp></sidebar-cmp>
    </div>
    <div class="main-panel">
        <navbar-cmp></navbar-cmp>
        <router-outlet></router-outlet>
        <!-- <div *ngIf="!isMap()"> -->
            <footer-cmp></footer-cmp>
        <!-- </div> -->
    </div>

</div>

<!-- Temporarily took this feature out -->
<!-- <fixedplugin-cmp></fixedplugin-cmp> -->



// WEBPACK FOOTER //
// ./src/app/layouts/admin-layout/admin-layout.component.html